import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BooleanConverter, NumberConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
import { TableCellWrapMode, TableColumnSortMode } from './table-types';
/* tslint:disable:template-cyclomatic-complexity */
var TableComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TableComponent, _super);
    function TableComponent(_vcr, cdr, renderer) {
        var _this = _super.call(this, _vcr, true) || this;
        _this._vcr = _vcr;
        _this.cdr = cdr;
        _this.renderer = renderer;
        _this._canResizeColumns = false;
        _this._canSelectRows = false;
        _this._columnSettings = [];
        _this._columnSortMode = TableColumnSortMode.None;
        _this._data = null;
        _this._hasRowDetails = false;
        _this._isChildTable = false;
        _this._isColumnSizeFixed = false;
        _this._isFilterEnabled = false;
        _this._isLoading = true;
        _this._pageSize = 10;
        _this._selectedRowIds = [];
        _this._showColumnHeaders = false;
        _this._showFooter = false;
        _this._tableCellWrapMode = TableCellWrapMode.Ellipsis;
        _this._tableHeight = '100%';
        _this.defaultSort = {
            descending: true,
            field: 'id'
        };
        _this.filterDebounce = 500;
        _this.filteredData = [];
        _this.filterSettings = [];
        _this.filterSubject = new Subject();
        _this.isColumnResizing = false;
        _this.numPagesLoaded = 1;
        _this.scrollToBottomDistance = 65;
        _this.sortSettings = [];
        _this.tableScrollPosition = 0;
        _this.updateTime = new Date();
        _this.rowDetailsTemplate = null;
        _this.tableFooterTemplate = null;
        _this.buttonClickEvent = new EventEmitter();
        _this.columnResizeEvent = new EventEmitter();
        _this.expandCollapseEvent = new EventEmitter();
        _this.filterEvent = new EventEmitter();
        _this.rowSelectionEvent = new EventEmitter();
        _this.sortEvent = new EventEmitter();
        _this.registerEvent('buttonClickEvent', _this.buttonClickEvent);
        _this.registerEvent('columnResizeEvent', _this.columnResizeEvent);
        _this.registerEvent('expandCollapseEvent', _this.expandCollapseEvent);
        _this.registerEvent('filterEvent', _this.filterEvent);
        _this.registerEvent('rowSelectionEvent', _this.rowSelectionEvent);
        _this.registerEvent('sortEvent', _this.sortEvent);
        return _this;
    }
    Object.defineProperty(TableComponent.prototype, "canResizeColumns", {
        get: function () {
            return this._canResizeColumns;
        },
        set: function (value) {
            this._canResizeColumns = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "canSelectRows", {
        get: function () {
            return this._canSelectRows;
        },
        set: function (value) {
            this._canSelectRows = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "columnCount", {
        get: function () {
            return this.columnSettings.length + Number(this.canSelectRows) + Number(this.rowDetailsTemplate != null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "columnSettings", {
        get: function () {
            return this._columnSettings;
        },
        set: function (value) {
            var _this = this;
            this._columnSettings = typeof value === 'string' ? JSON.parse(value) : value;
            this.filterSettings.forEach(function (filterSetting) {
                var column = _this._columnSettings.find(function (columnSetting) { return filterSetting.field === columnSetting.propertyName; });
                if (column) {
                    column.filter = filterSetting.value;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "columnSortMode", {
        get: function () {
            return this._columnSortMode;
        },
        set: function (value) {
            this._columnSortMode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            var initTable = this._data == null && value != null;
            this._data = typeof value === 'string' ? JSON.parse(value) : value;
            if (initTable) {
                this.filteredData = tslib_1.__spread(this.data);
                this.applyFilter(true);
                this.applySort();
                this.toggleLoading(false);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "dataIDPropertyName", {
        get: function () {
            return this.defaultSort.field;
        },
        set: function (value) {
            this.defaultSort.field = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "hasRowDetails", {
        get: function () {
            return this._hasRowDetails;
        },
        set: function (value) {
            this._hasRowDetails = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "isChildTable", {
        get: function () {
            return this._isChildTable;
        },
        set: function (value) {
            this._isChildTable = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "isColumnSizeFixed", {
        get: function () {
            return this._isColumnSizeFixed;
        },
        set: function (value) {
            this._isColumnSizeFixed = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "isLoadingOverlayDisplayed", {
        get: function () {
            return this.columnSettings.length === 0 || this.isLoading || this.filteredData === null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "isFilterEnabled", {
        get: function () {
            return this._isFilterEnabled;
        },
        set: function (value) {
            this._isFilterEnabled = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        set: function (value) {
            this.toggleLoading(BooleanConverter(value));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (value) {
            this._pageSize = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "rowsForDisplay", {
        get: function () {
            return this.filteredData.slice(0, this.numPagesLoaded * this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "selectedRowIds", {
        get: function () {
            return this._selectedRowIds;
        },
        set: function (value) {
            this._selectedRowIds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "showColumnHeaders", {
        get: function () {
            return this._showColumnHeaders;
        },
        set: function (value) {
            this._showColumnHeaders = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "showFooter", {
        get: function () {
            return this._showFooter;
        },
        set: function (value) {
            this._showFooter = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "tableCellWrapMode", {
        get: function () {
            return this._tableCellWrapMode;
        },
        set: function (value) {
            this._tableCellWrapMode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TableComponent.prototype, "tableHeight", {
        get: function () {
            return this._tableHeight;
        },
        set: function (value) {
            this._tableHeight = value;
        },
        enumerable: true,
        configurable: true
    });
    TableComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.tableContainer.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
                this.filterSubject.pipe(debounceTime(this.filterDebounce)).subscribe(function () {
                    _this.toggleLoading(true);
                    setTimeout(function () {
                        _this.applyFilter(true);
                        _this.toggleLoading(false);
                    }, 10);
                });
                return [2 /*return*/];
            });
        });
    };
    TableComponent.prototype.applyFilter = function (triggerEvent) {
        var _this = this;
        this.filteredData = tslib_1.__spread(this.data);
        var filterSettings = [];
        this.columnSettings.forEach(function (column) {
            if (column.canFilter && column.filter && column.filter !== '') {
                _this.filteredData = _this.filteredData.filter(function (data) { return !data[column.propertyName] ? false : data[column.propertyName].toString().toLowerCase().includes(column.filter.toLowerCase()); });
                filterSettings.push({
                    field: column.propertyName,
                    operator: 'like',
                    value: column.filter
                });
            }
        });
        if (triggerEvent) {
            this.filterEvent.emit({ filteredData: this.filteredData, filterSettings: filterSettings });
        }
    };
    TableComponent.prototype.applySort = function () {
        var sortSettingsToApply = this.sortSettings.length === 0 ? [this.defaultSort] : this.sortSettings;
        this.filteredData.sort(function (a, b) {
            var e_1, _a;
            try {
                for (var sortSettingsToApply_1 = tslib_1.__values(sortSettingsToApply), sortSettingsToApply_1_1 = sortSettingsToApply_1.next(); !sortSettingsToApply_1_1.done; sortSettingsToApply_1_1 = sortSettingsToApply_1.next()) {
                    var sortSetting = sortSettingsToApply_1_1.value;
                    var aValue = a[sortSetting.field];
                    var bValue = b[sortSetting.field];
                    if (aValue < bValue) {
                        return !sortSetting.descending ? -1 : 1;
                    }
                    else if (aValue > bValue) {
                        return !sortSetting.descending ? 1 : -1;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (sortSettingsToApply_1_1 && !sortSettingsToApply_1_1.done && (_a = sortSettingsToApply_1.return)) _a.call(sortSettingsToApply_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return 0;
        });
    };
    TableComponent.prototype.onButtonClick = function (dataItem, event) {
        this.buttonClickEvent.emit({ data: dataItem, event: event });
    };
    TableComponent.prototype.onFilter = function () {
        this.filterSubject.next();
    };
    TableComponent.prototype.onScroll = function (_event) {
        var _this = this;
        // When scrolling down and scroll position just above last item and there are more items to load
        if (this.numPagesLoaded * this.pageSize < this.filteredData.length && this.tableScrollPosition < this.tableContainer.nativeElement.scrollTop && this.tableContainer.nativeElement.scrollTop >= this.tableContainer.nativeElement.scrollHeight - this.tableContainer.nativeElement.clientHeight - this.scrollToBottomDistance) {
            this.toggleLoading(true);
            this.numPagesLoaded++;
            setTimeout(function () {
                _this.toggleLoading(false);
            }, 500);
        }
        this.tableScrollPosition = this.tableContainer.nativeElement.scrollTop;
    };
    TableComponent.prototype.onSortChange = function (propertyName) {
        var _this = this;
        if (!this.isColumnResizing && this.columnSortMode !== TableColumnSortMode.None && this.columnSettings.find(function (column) { return column.propertyName === propertyName; }).canSort) {
            this.toggleLoading(true);
            setTimeout(function () {
                var sortedProperty = _this.sortSettings.find(function (setting) { return setting.field === propertyName; });
                if (!sortedProperty) {
                    var newSortedProperty = {
                        descending: false,
                        field: propertyName
                    };
                    _this.sortSettings.splice(0, _this.columnSortMode === TableColumnSortMode.Single ? 1 : 0, newSortedProperty);
                }
                else {
                    if (sortedProperty.descending) {
                        _this.sortSettings.splice(_this.sortSettings.indexOf(sortedProperty), 1);
                    }
                    else {
                        sortedProperty.descending = true;
                    }
                }
                _this.applySort();
                // Trigger pipe change detection
                _this.updateTime = new Date();
                _this.sortEvent.emit({ sortSettings: _this.sortSettings });
                _this.toggleLoading(false);
            }, 10);
        }
    };
    TableComponent.prototype.resizeColumn = function (columnResizer, propertyName, event) {
        var _this = this;
        this.isColumnResizing = true;
        var tableHeaderElement = columnResizer.parentElement;
        var tableRow = tableHeaderElement.parentElement;
        var tableRowCells = Array.from(tableRow.children);
        this.columnResizeIndex = tableRowCells.indexOf(tableHeaderElement);
        this.columnResizeStart = event.pageX;
        this.initialWidth = tableHeaderElement.offsetWidth;
        this.newWidth = null;
        var onMouseMove = function (mouseMoveEvent) {
            if (_this.isColumnResizing) {
                _this.newWidth = _this.initialWidth + mouseMoveEvent.pageX - _this.columnResizeStart;
                var tableHeaderTextContainer = tableHeaderElement.querySelectorAll('div')[0];
                if (_this.newWidth !== _this.initialWidth && _this.newWidth >= Number(getComputedStyle(tableHeaderTextContainer).getPropertyValue('min-width').replace('px', ''))) {
                    var margin = Number(getComputedStyle(tableHeaderElement).getPropertyValue('margin-left').replace('px', '')) + Number(getComputedStyle(tableHeaderElement).getPropertyValue('margin-right').replace('px', ''));
                    var padding = Number(getComputedStyle(tableHeaderElement).getPropertyValue('padding-left').replace('px', '')) + Number(getComputedStyle(tableHeaderElement).getPropertyValue('padding-right').replace('px', ''));
                    _this.newWidth -= margin + padding;
                    _this.renderer.setStyle(tableHeaderElement, 'width', _this.newWidth + "px");
                    _this.renderer.setStyle(tableHeaderTextContainer, 'width', _this.newWidth + "px");
                    _this.table.nativeElement.querySelectorAll('tr').forEach(function (row) {
                        var cells = row.querySelectorAll('td');
                        if (cells[_this.columnResizeIndex]) {
                            var contentContainer = cells[_this.columnResizeIndex].querySelectorAll('div')[0];
                            if (contentContainer !== undefined) {
                                _this.renderer.setStyle(contentContainer, 'max-width', _this.newWidth + "px");
                            }
                        }
                    });
                }
            }
        };
        var onMouseUp = function () {
            // Slight delay to prevent sorting event from executing
            setTimeout(function () { _this.isColumnResizing = false; }, 50);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            _this.columnResizeEvent.emit({ propertyName: propertyName, width: _this.newWidth });
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };
    TableComponent.prototype.selectAllRows = function () {
        var _this = this;
        if (this.selectedRowIds.length) {
            this.selectedRowIds = [];
        }
        else {
            this.selectedRowIds = this.filteredData.map(function (data) { return data[_this.dataIDPropertyName]; });
        }
        // Trigger pipe change detection
        this.updateTime = new Date();
        this.rowSelectionEvent.emit({ selectedRowIds: this.selectedRowIds });
    };
    TableComponent.prototype.selectRow = function (id) {
        var itemIndex = this.selectedRowIds.indexOf(id);
        if (itemIndex < 0) {
            this.selectedRowIds.push(id);
        }
        else {
            this.selectedRowIds.splice(itemIndex, 1);
        }
        // Trigger pipe change detection
        this.updateTime = new Date();
        this.rowSelectionEvent.emit({ selectedRowIds: this.selectedRowIds });
    };
    TableComponent.prototype.toggleLoading = function (isLoading) {
        this._isLoading = isLoading;
        this.cdr.detectChanges();
    };
    TableComponent.prototype.toggleRowExpandCollapse = function (dataItem) {
        dataItem.isExpanded = !dataItem.isExpanded;
        this.expandCollapseEvent.emit({ data: dataItem });
    };
    return TableComponent;
}(BaseComponent));
export { TableComponent };
